<template>
	<div class="home">
		<top></top>
		<lbt></lbt>
		<bar></bar>
	</div>
</template>

<script>
	// @ is an alias to /src
	import top from '@/components/top.vue'
	import lbt from '@/components/lbt.vue'
	import bar from '@/components/bar.vue'
	export default {
		name: 'HomeView',
		components: {
			top,
			lbt,
			bar,
		},
		data() {
			return {
				
			}
		},
		methods:{
			
		}
	}
</script>
<style scoped lang="less">
	.home{
		width: 100vw;
		height: 100vh;
		position: relative;
		overflow: hidden;
	}
	.h_bon{
		position: absolute;
		bottom: 0;
		left: 0;
		z-index: 10;
	}
</style>